const verifikasi = {
  namespaced: true,

  states: {
    statusVendor: 'N',
    statusPerusahaan: 'N',
    statusIjin: 'N',
    statusAkta: 'N',
    statusPemilik: 'N',
    statusPengurus: 'N',
    statusPengalaman: 'N',
    statusPajak: 'N'
  },

  getters: {
    statusPerusahaan: state => state.statusPerusahaan,
    statusIjin: state => state.statusIjin,
    statusAkta: state => state.statusAkta,
    statusPemilik: state => state.statusPemilik,
    statusPengurus: state => state.statusPengurus,
    statusPengalaman: state => state.statusPengalaman,
    statusPajak: state => state.statusPajak,
  },

  mutations: {
 
  },

  actions: {

  }
}

export default verifikasi